/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Mukama 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Bufunda": ["Bitabo", "Bufunda", "Kibihanga", "Nyakajeje", "Rebero"],
  "Gatete": ["Gatete I", "Gatete II", "Hunga", "Kazinga", "Rutete", "Ryandahuka"],
  "Gihengeri": ["Butare", "Butwaro", "Gashahi", "Gihengeri", "Gishoro", "Kabongoya I", "Kabongoya II", "Kigarama", "Nyarubuye"],
  "Gishororo": ["Akinyambo", "Byumba", "Kabeza", "Kabukunzi", "Kisaro"],
  "Kagina": ["Cyabahurura", "Kagonga", "Kireranyana", "Ngoma", "Nyagatare", "Nyakagarama", "Nyakarama"],
  "Rugarama": ["Bukire", "Byimana", "Kibondo", "Kireranyana", "Nyacyonga", "Nyakagarama", "Sipure"]
};